import { SelectIF } from '@/types/common';

export type FitT =
    | 'Fitted'
    | 'Loose'
    | 'Oversized'
    | 'Straight'
    | 'TightFitting'
    | 'SemiFitted';

export type LowerFitT = 'Straight' | 'Slim' | 'Wide' | 'Flared';

export const FITS_PROPERTIES: SelectIF<FitT>[] = [
    { value: 'Fitted', label: 'Приталенный' },
    { value: 'Loose', label: 'Свободный' },
    { value: 'Oversized', label: 'Оверсайз' },
    { value: 'Straight', label: 'Прямой' },
    { value: 'TightFitting', label: 'Облегающий' },
    { value: 'SemiFitted', label: 'Полуприлегающий' },
];

export const LOWER_FITS_PROPERTIES: SelectIF<LowerFitT>[] = [
    { value: 'Straight', label: 'Прямой' },
    { value: 'Slim', label: 'Зауженный' },
    { value: 'Wide', label: 'Широкий' },
    { value: 'Flared', label: 'Расклешенный' },
];
